import React from 'react';
import {
  Button,
  Icon,
} from 'anf-core-react';
import useSaves from './useSaves';

const SAVE_BUTTON_STATES = {
  DEFAULT: {
    value: 'DEFAULT',
    textKey: 'saveForLater',
    icon: 'heart-outline',
  },
  ADDING: {
    value: 'ADDING',
    textKey: 'processingSave',
    icon: '',
  },
  REMOVING: {
    value: 'REMOVING',
    textKey: 'processingRemove',
    icon: '',
  },
  SAVED: {
    value: 'SAVED',
    textKey: 'saved',
    icon: 'heart-filled',
  },
};

export default function AddToListButton({
  kic,
  sku,
  productId,
  tmntData = {},
  store,
  storeId,
}) {
  const { buttonState, handleSavesClick } = useSaves(productId, kic, sku, store, storeId);
  const isProcessing = buttonState === 'ADDING' || buttonState === 'REMOVING';

  return (
    <Button
      variant="tertiary-light"
      classList="add-to-list-button"
      isProcessing={isProcessing}
      isDisabled={isProcessing}
      isFullWidth
      onClick={handleSavesClick}
    >
      {SAVE_BUTTON_STATES[buttonState]?.icon && <Icon icon={SAVE_BUTTON_STATES[buttonState]?.icon} />}
      {tmntData[SAVE_BUTTON_STATES[buttonState]?.textKey]?.value}
    </Button>
  );
}
